<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单号</label>
            <em class="weui-form-preview__value">{{ form.main.pc_code }}</em>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">采购信息</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商名称</label>
            <span class="weui-form-preview__value">{{
              form.main.pu_vendname
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">联系人</label>
            <span class="weui-form-preview__value">{{
              form.main.pu_contact
            }} {{
              form.main.pu_tel
            }}<call-mobile :em-id="form.main.pu_tel"></call-mobile></span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">交货地址</label>
            <span class="weui-form-preview__value">{{
              form.main.pu_shipaddresscode
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">付款方式</label>
            <span class="weui-form-preview__value">{{
              form.main.pu_payments
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{
              form.main.pu_currency
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">采购单号</label>
            <span class="weui-form-preview__value">{{
              form.main.pc_pucode
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">采购序号</label>
            <span class="weui-form-preview__value">{{
              form.main.pc_pdno
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_code
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_detail
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{
              form.main.pu_remark
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_spec
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">采购员</label>
            <span class="weui-form-preview__value">{{
              form.main.pu_buyername
            }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">变更信息</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更人</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{
              form.main.pc_auditman
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更原因</label>
            <span class="weui-form-preview__value">{{
              form.main.pc_reason
            }}</span>
          </div>
          <change-field
            label="数量"
            :old-value="oldItem.pd_qty"
            :new-value="newItem.pd_qty"
          />
          <change-field
            label="不含税单价"
            :old-value="oldItem.pd_taxprice"
            :new-value="newItem.pd_taxprice"
          />
          <change-field
            label="含税单价"
            :old-value="oldItem.pd_price"
            :new-value="newItem.pd_price"
          />
          <change-field
            label="税率"
            :old-value="oldItem.pd_taxrate"
            :new-value="newItem.pd_taxrate"
          />
          <change-field
            label="需求日期"
            :formatDate="true"
            :old-value="oldItem.pd_delivery"
            :new-value="newItem.pd_delivery"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChangeField from "@/components/field/ChangeField";
import form from "@/mixins/form.js";
import CallMobile from "@/components/button/CallMobile.vue";

export default {
  mixins: [form],
  components: {
    ChangeField,
    CallMobile
  },
  data() {
    return {
      baseUrl: "/api/purchase/change",
    };
  },
  computed: {
    oldItem() {
      var items = this.form.items;
      return items && items.length == 2 ? items[0] : {};
    },
    newItem() {
      var items = this.form.items;
      return items && items.length == 2 ? items[1] : {};
    },
  },
};
</script>